import {gv_fun_env} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
import {enum_projectEnv_s} from "../../../functions/src/shareCode/Share_S_Enum";

export const google_signIn_fp = () => {
    return googleLoad_fp().then((auth2) => {
        if(auth2){
            return auth2.signIn().then((ans_o) => {
                return google_getGoogleIdTokenFromSignInAns_s(ans_o)
            })
        }else{
            const err = { err: 'Script not loaded correctly, did you added the plugin or the client_id to the component?' };
            return Promise.reject(err);
        }
    })
};

// gmail_getGoogleIdTokenFromSignInAns_s
export const google_getGoogleIdTokenFromSignInAns_s = (signInAns_o) => {
    return signInAns_o.getAuthResponse().id_token
}

// gmail_signOut_f
export const google_signOut_f = () => {
    if(auth2){
        return auth2.signOut()
    }else{
        const err = { err: 'Script not loaded correctly, did you added the plugin or the client_id to the component?' };
        return Promise.reject(err);
    }
};

// ================ private =====================

const onLoadGoogle_s = 'onLoadGoogle'
const auth2_script_id = 'auth2_script_id'
const params = {
    client_id: gv_fun_env.currentProject_e === enum_projectEnv_s.tq_pro
        // ? "478048304316-pt4s7skr09vvtfbl4nil9vib9uba9o0n.apps.googleusercontent.com"
        ? "478048304316-3o1494a2shaov4j47rd1ugoego80re36.apps.googleusercontent.com"
        : "329212265305-rn1f9u288k0cquh2nig6h8h8cns9lcpp.apps.googleusercontent.com",
    ux_mode : 'popup'
}

// gmail_load_fp
let loadAns_p = null
const googleLoad_fp = () => {

    if(loadAns_p == null){
        loadAns_p = new Promise((resolve, reject) => {

            window[onLoadGoogle_s] = () => {

                window.gapi.load('auth2', () => {
                    try {
                        let auth2 = window.gapi.auth2.init(Object.assign({}, params));
                        resolve(auth2);
                    } catch (err) {
                        reject({err: 'client_id missing or is incorrect, or if you added extra params maybe they are written incorrectly, did you add it to the component or plugin?'})
                    }
                })
            }

            createScript_f()
        })

    }
    return loadAns_p
}

// createScript_f
const createScript_f = () => {
    const el = document.getElementById(auth2_script_id);
    if (!el) {
        let script = document.createElement('script')
        script.setAttribute('src', `https://apis.google.com/js/platform.js?onload=${onLoadGoogle_s}`)
        script.setAttribute("async", true)
        script.setAttribute("defer", "defer")
        script.setAttribute("id", auth2_script_id)
        document.head.appendChild(script);
    }
}




